import React from 'react';
import PropTypes from 'prop-types';
import { TooltipUpdaterConsumer } from '../atoms/Tooltip';

const TooltipIcon = ({ children }) => (
  <TooltipUpdaterConsumer>
    {({ setTooltip, clearTooltip }) => (
      <div
        className="iconWrapper"
        onMouseOver={(e) => {
          setTooltip(e.currentTarget, children);
        }}
        onMouseLeave={clearTooltip}
      >
        <img
          className="questionIcon"
          src="/dp-air/img/icons/question.png"
        />
      </div>
    )}
  </TooltipUpdaterConsumer>
);

TooltipIcon.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TooltipIcon;
